import React from 'react';
import PropTypes from 'prop-types';
import AuthenticationFactorListItemActionOptional from './AuthenticationFactorListItemActionOptional';
import AuthenticationFactorListItemActionRequired from './AuthenticationFactorListItemActionRequired';

const AuthenticationFactorListItemActionPicker = ({ authenticationFactorResource }) => {
  // Assume if auth factor is required
  let Component = AuthenticationFactorListItemActionRequired;

  // If not required then show the switch
  if (!authenticationFactorResource.isTruthy('isRequired')) {
    Component = AuthenticationFactorListItemActionOptional;
  }

  return (<Component authenticationFactorResource={authenticationFactorResource} />);
};

AuthenticationFactorListItemActionPicker.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorListItemActionPicker;
